export default "__VITE_ASSET__vjF7rL9L__"